import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCarousel = ({ categories }) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  // Limit to only 6 categories for uniform display
  const displayCategories = categories.slice(0, 6);

  return (
    <div className="container mx-auto px-4">
      {/* Horizontal Scrollable Category Row - Max 6 categories */}
      <div className="flex gap-6 overflow-x-auto pb-4 justify-center" style={{ scrollbarWidth: 'thin', scrollbarColor: '#8B4513 #f0f0f0' }}>
        {displayCategories.map((category) => (
          <Link
            key={category._id}
            to={`/category/${category._id}`}
            className="flex-shrink-0 flex flex-col items-center group cursor-pointer"
            style={{ minWidth: '120px', maxWidth: '120px' }}
          >
            {/* Category Icon/Image - Uniform size */}
            <div className="w-24 h-24 rounded-full overflow-hidden bg-white border-2 border-gray-200 shadow-md mb-3 group-hover:shadow-lg group-hover:border-primary transition-all duration-300 flex items-center justify-center">
              {category.image ? (
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover image-zoom"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div class="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary to-primary-dark text-white text-2xl font-bold">' + category.name.charAt(0).toUpperCase() + '</div>';
                  }}
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary to-primary-dark text-white text-2xl font-bold">
                  {category.name.charAt(0).toUpperCase()}
                </div>
              )}
            </div>
            
            {/* Category Name - Uniform styling */}
            <span className="text-sm font-semibold text-gray-800 group-hover:text-primary transition-colors text-center w-full">
              {category.name}
            </span>
          </Link>
        ))}
      </div>
      
      <style>{`
        /* Custom scrollbar styling for webkit browsers */
        .overflow-x-auto::-webkit-scrollbar {
          height: 8px;
        }
        .overflow-x-auto::-webkit-scrollbar-track {
          background: #f0f0f0;
          border-radius: 4px;
        }
        .overflow-x-auto::-webkit-scrollbar-thumb {
          background: #8B4513;
          border-radius: 4px;
        }
        .overflow-x-auto::-webkit-scrollbar-thumb:hover {
          background: #654321;
        }
      `}</style>
    </div>
  );
};

export default CategoryCarousel;

